<template>
  <div class="score_box">
    <p class="little-large_white_label">{{ user.displayName }}</p>
    <div v-if="client && client.scores">
      <p>あなたのクライアント評価</p>
      <p>総合:{{ total }}</p>
      <p>作業指示の明快さ:{{ accuracy }}</p>
      <p>契約金額適切さ:{{ cost }}</p>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "ClientScoreBox",

    props: {
      client: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters({user: 'auth/user'}),

      total() {
        return this.client.scores.total ? Math.round(this.client.scores.total * 10) / 10 : ''
      },
      accuracy() {
        return this.client.scores.accuracy ? Math.round(this.client.scores.accuracy * 10) / 10 : ''
      },
      cost() {
        return this.client.scores.cost ? Math.round(this.client.scores.cost * 10) / 10 : ''
      },
    },
  }
</script>

<style lang="scss" scoped>
  .score_box {
    position: fixed;
    display: flex;
    flex-flow: column;
    align-items: flex-end;
    right: 2rem;

    > div {
      background-color: $client_third;
      padding: 2rem;
      color: $base_color;
      width: 25rem;
    }

    @media screen and (max-width: 767px) {
      position: static;
      align-items: center;
    }
  }
</style>